/* Catálogo: los selects de filtros/orden envían el form al cambiar; el de categoría navega a la colección;
   "Ver más productos" añade la página siguiente sin recargar (sin JS es un enlace normal). */
(() => {
  document.querySelectorAll('form[data-filters]').forEach((form) => {
    form.querySelectorAll('[data-no-js]').forEach((b) => b.classList.add('sr-only'));
    form.addEventListener('change', (e) => {
      if (e.target.matches('[data-nav-select]')) { location.href = e.target.value; return; }
      // No mandar parámetros vacíos (filtros sin elegir).
      const params = new URLSearchParams();
      new FormData(form).forEach((v, k) => { if (v !== '') params.append(k, v); });
      location.href = `${form.action}${params.toString() ? `?${params}` : ''}`;
    });
  });

  document.addEventListener('click', async (e) => {
    const link = e.target.closest('[data-load-more]');
    if (!link) return;
    e.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return; // doble clic: ya hay una petición en curso
    link.dataset.label ??= link.textContent;
    const label = link.dataset.label;
    link.textContent = link.dataset.loading;
    link.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(link.href);
      if (!res.ok) throw new Error(`page ${res.status}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = document.querySelector('[data-product-grid]');
      doc.querySelectorAll('[data-product-grid] > *').forEach((card) => grid.append(card));
      const next = doc.querySelector('[data-load-more]');
      if (next) { link.href = next.href; link.textContent = label; link.removeAttribute('aria-busy'); }
      else link.parentElement.remove();
    } catch (_) {
      link.textContent = label; // se conserva el botón para reintentar
      link.removeAttribute('aria-busy');
    }
  });
})();
